module.exports = "/images/congrats.png?3947286be8ab9c47dbb34313e6954e12";